import React from 'react';
import IScroll from 'iscroll';
import GiftItem from '../common/gift-item';
import ProjectDetailPb from '../../pb/giftitemdetail.pb';
import GiftListPb from '../../pb/giftomallgiftlist.pb';
import {giftMallService, giftService} from '../../config';
import './step1.less';
import {GiftoIcon} from '../../component/gifto-icon';
import {createStepOneSave, enterCreateStepOne} from '../../ga-config';

const getProjectById = giftService('/gift/item/detail', ProjectDetailPb.Gift.ItemDetail);
const getGiftList = giftMallService('/gifto/mall/gift/list', GiftListPb.Gifto.Mall.GiftList);

export default class Step1 extends React.Component {
    static defaultProps = {
        //  如果上面传进来的了id，就需要请求这个项目的数据，填充表单，以备修改
        id: null,
        giftList: [],
        onCommit(data) {
            console.log(data);
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            showClose: true, // 没有项目的时候就不显示关闭按钮
            giftItemList: [], //  所有的礼物列表
            giftList: [],
            itemName: '',
            itemDesc: '',
            itemId: props.id
        };
    }

    componentDidMount() {
        if (this.state.itemId) {
            this.fetchProjectDetail(this.state.itemId);
        }
        this.fetchGiftList();
        GA.add(enterCreateStepOne);
    }

    componentDidUpdate(props, state) {
        this._scroll && this._scroll.refresh();
    }

    componentWillUnmount() {
        if (this._scroll) {
            this._scroll.destroy();
            this._scroll = null;
        }
    }

    fetchProjectDetail(itemId) {
        UG.loading(UG.lang.template('Loading...'));
        getProjectById({itemId, uid: UG.getUser().uid})
            .then(({itemInfos}) => {
                const {itemName, itemDesc, giftList} = itemInfos;
                //  选中的礼物ids
                this.setState({
                    itemId,
                    itemName,
                    itemDesc,
                    giftList: giftList.map(item => {
                        return item.giftId;
                    })
                });
            })
            .finally(() => {
                UG.loaded();
            });
    }

    fetchGiftList() {
        UG.loading(UG.lang.template('Loading...'));
        getGiftList({scene: 5}).then(({gifts, amountConfigs}) => {
            this.setState({
                // 只显示online的礼物
                giftItemList: gifts.filter(item => {
                    return item.onLined && [12, 1].indexOf(item.type) !== -1;
                })
            }, () => {
                this._scroll = new IScroll('#ci-scroll-wrapper', {
                    mouseWheel: true,
                    click: UG.iScrollClick(),
                    tap: true
                });
            });
        }).catch(err => {
            console.log(err);
        }).finally(() => {
            UG.loaded();
        });
    }

    setInputValue(which, event) {
        this.setState({[which]: event.target.value});
    }

    onCommit = () => {
        const {itemId, itemName, itemDesc, giftList} = this.state;
        if (!itemName) {
            // 项目名称不能为空
            return UG.simple(UG.lang.template('Please name your dashboard.'));
        }
        if (itemName.length > 30) {
            return UG.simple(UG.lang.template('Limit of Name is 30 characters.'));
        }
        if (itemDesc && itemDesc.length > 120) {
            return UG.simple(UG.lang.template('Limit is Description is 120 characters.'));
        }
        if (!giftList || giftList.length < 1) {
            return UG.simple(UG.lang.template('建议至少选择3~5礼物'));
        }
        if (giftList.length > 50) {
            return UG.simple(UG.lang.template('50 gifts in one Gift Dashboard only.'));
        }
        UG.loading(UG.lang.template('Loading...'));
        GA.add(createStepOneSave);
        this.props.onCommit({
            itemId,
            itemName,
            itemDesc,
            //  需要将id包装成 {giftId:id}的对象
            giftList: giftList.map(item => {
                return {giftId: item};
            })
        }, () => {
            UG.loaded();
        });
    };

    /**
     * 选中一个礼物触发这个事件
     * @param id 礼物id
     * @param result 选中状态
     */
    onSelectItem = (id, result) => {
        let list = this.state.giftList.concat();
        if (result) {
            if (list.indexOf(id) === -1) {
                list.push(id);
            }
        } else {
            const index = list.indexOf(id);
            if (index > -1) {
                list.splice(index, 1);
            }
        }
        this.setState({giftList: list});
    };

    removeFocus = () => {
        //  如果不加这个，点击iscroll区域不会导致其他的文本框失去焦点，会导致每点击一次iscroll区域，手机端就会弹出键盘
        $('input,textarea').blur();
    };

    render() {
        const {itemName, itemDesc, giftItemList} = this.state;
        return (
            <div className="ci-step1">
                <div className="ci-title-block">
                    <p>{UG.lang.template('Gifts')}</p>
                </div>
                <div id="ci-scroll-wrapper" onClick={this.removeFocus}>
                    <div className="ci-step1-gift-list">
                        {
                            (giftItemList && giftItemList.length) ? giftItemList.map((item, index) => {
                                let image = '';
                                if (item.resources.length) {
                                    item.resources.forEach((item) => {
                                        if (item.type === 3) {
                                            image = item.url;
                                        }
                                    });
                                }
                                return (
                                    <GiftItem
                                        key={index}
                                        id={item.giftId}
                                        image={image}
                                        name={item.name}
                                        selectable={true}
                                        selected={this.state.giftList.indexOf(item.giftId) !== -1}
                                        vipGrade={item.vipGrade}
                                        onSelect={this.onSelectItem}>
                                        <GiftoIcon size="0.4375rem"/>
                                        <div>{Number(item.price) || 0}</div>
                                    </GiftItem>
                                );
                            }) : (
                                <div className="no-gift">{UG.lang.template('没有找到匹配的礼物')}</div>
                            )
                        }
                    </div>
                </div>
                <div className="ci-title-block">
                    <p>{UG.lang.template('Name this Dashboard')}</p>
                </div>
                <div className="ci-step1-input">
                    <input
                        type="text"
                        value={itemName}
                        onChange={this.setInputValue.bind(this, 'itemName')}
                        placeholder={UG.lang.template('Enter project name')}/>
                </div>
                <div className="ci-title-block">
                    <p>{UG.lang.template('Description')}</p>
                </div>
                <div className="ci-step1-input">
                    <textarea
                        value={itemDesc}
                        onChange={this.setInputValue.bind(this, 'itemDesc')}
                        placeholder={UG.lang.template('Describe this dashboard')}/>
                </div>
                <div className="text-center">
                    <button type="button" className="btn-cus btn-lg" onClick={this.onCommit}>
                        {UG.lang.template('Save Dashboard')}
                    </button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/host/gift/step1.js